// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","wrapper":"wrapper-_mc9g","text":"text-cWNUG","scrollBody":"scrollBody-677If","paper":"paper-2TAVv"};